import React, {useEffect, useState} from 'react'
import _ from "lodash";
import {searchQuotesWithSearchCriteria} from "../../../common/services/quote-data-service";
import {searchDesigns} from "../../services/design-data-service";
import {searchParentProducts} from "../../../pod/services/parent-product-data-service";
import CopyDesigns from "../copy-designs/copy-designs";
import DownloadDesignVariants from "../download/download-design-variants";
import ShowDesignStatistics from "../common/show-design-statistics";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {ADD_MULTIPLE_DESIGNS_TABS_LIST, DEFAULT_ADD_MULTIPLE_DESIGNS_TAB} from "../../constants/design.constant";
import ParentProductDetail from "../../../pod/components/parent-product/edit-parent-product/parent-product-detail";
import {getAllTags} from "../../../common/services/tag-data-service";

const IGNORE_COPY_ATTRIBUTES = ['id', 'createdAt', 'updatedAt', 'statistics'];
const tabsList = ADD_MULTIPLE_DESIGNS_TABS_LIST;

const MultipleDesignDetails = ({
                                   designList,
                                   setDesignList,
                                   podList,
                                   themeList,
                                   selectedPod,
                                   setSelectedPod,
                                   parentProduct,
                                   setParentProduct,
                                   quoteList,
                                   setQuoteList,
                                   setExcludeTemplate
                               }) => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_ADD_MULTIPLE_DESIGNS_TAB);
    const [selectedProductType, setSelectedProductType] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedParentProduct, setSelectedParentProduct] = useState(null);
    /*const [parentProduct, setParentProduct] = useState(null);*/
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [selectedDesignList, setSelectedDesignList] = useState(null);
    const [selectedDesignByQuoteMap, setSelectedDesignByQuoteMap] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    // const [quoteList, setQuoteList] = useState(null);
    const [commonDetail, setCommonDetail] = useState(null);
    const [existingDesignQuoteList, setExistingDesignQuoteList] = useState(null);
    const [allTags, setAllTags] = useState([]);

    useEffect(() => {
        if (selectedTheme) {
            getTagsList();
            getAllQuoteList();
        }
    }, [selectedTheme]);

    const getTagsList = async () => {
        const tagsListResult = await getAllTags();
        setAllTags(tagsListResult);
    }

    const getAllQuoteList = async () => {
        const quoteListResult = await searchQuotesWithSearchCriteria(prepareSearchCriteria());
        setQuoteList(_.orderBy(quoteListResult, ['startText']));
    }

    const prepareSearchCriteria = () => {
        const searchCriteriaList = [];

        if (!_.isEmpty(selectedTheme)) {
            searchCriteriaList.push({field: 'themes.' + selectedTheme?.id, condition: '==', value: true});
        }

        return searchCriteriaList;
    }

    const handleDetailChanges = (event) => {
        const {name, value} = event.target;
        const existingCommonDetail = {...commonDetail};
        existingCommonDetail[name] = value;

        let currentParentProduct = {...selectedParentProduct};
        let currentTheme = {...selectedTheme};
        let currentSize = {...selectedSize};

        if (name === 'podId') {
            const podsMap = _.keyBy(podList, 'id');
            const tempPod = podsMap[value];
            setSelectedPod(tempPod);
            setSelectedProductType(null);

            existingCommonDetail.market = tempPod.market;
            existingCommonDetail.podName = tempPod.name;
        } else if (name === 'productType') {
            const productTypesMap = _.keyBy(selectedPod.productTypesList, 'name');
            const tempProductType = productTypesMap[value];
            setSelectedProductType(tempProductType);
            setSelectedCategory(null);
        } else if (name === 'category') {
            const categoriesMap = _.keyBy(selectedProductType.categories, 'name');
            const tempCategory = categoriesMap[value];
            setSelectedCategory(tempCategory);
            setSelectedParentProduct(null);
        } else if (name === 'parent') {
            const parentProductsMap = _.keyBy(selectedCategory.parentProducts, 'name');
            currentParentProduct = parentProductsMap[value];
            setSelectedParentProduct(currentParentProduct);
        } else if (name === 'size') {
            const sizesMap = _.keyBy(selectedParentProduct.sizes, 'name');
            currentSize = sizesMap[value];
            setSelectedSize(currentSize);
        } else if (name === 'themeId') {
            const themeMap = _.keyBy(themeList, 'id');
            currentTheme = themeMap[value];
            setSelectedTheme(currentTheme);

            existingCommonDetail.themeName = currentTheme.startText;
        }

        setCommonDetail(existingCommonDetail);

        if (name === 'parent') {
            getSingleParentProductByDesignDetail(currentParentProduct);
        } else if (name === 'podId' || name === 'productType' || name === 'category') {
            setParentProduct(null);
        }

        handleSearchDesigns(existingCommonDetail);
    }

    const toggleQuoteSelection = (quote, index) => {
        quote.selected = !quote.selected;

        if (quote.selected) {
            quote.designName = prepareName(quote);
        } else {
            quote.designName = '';
        }

        const existingQuoteList = [...quoteList];
        existingQuoteList[index] = quote;
        setQuoteList(existingQuoteList);

        prepareDesignList();
    }

    const selectAllQuotes = () => {
        const existingQuoteList = [...quoteList];

        _.forEach(existingQuoteList, quote => {
            if (existingDesignQuoteList?.indexOf(quote.startText) === -1 || selectedDesignByQuoteMap?.hasOwnProperty(quote.id)) {
                quote.selected = true;
                quote.designName = prepareName(quote);
            }
        })

        setQuoteList(existingQuoteList);
        prepareDesignList();
    }

    const prepareName = (quote) => {
        let designNameList = [];

        console.log('commonDetail: ', commonDetail);

        const themeMap = _.keyBy(themeList, 'id');
        const currentTheme = themeMap[commonDetail?.themeId];

        if (!_.isEmpty(quote)) {
            designNameList.push(quote.startText);
        }

        if (!_.isEmpty(currentTheme)) {
            designNameList.push(currentTheme.startText);
        }

        if (!selectedPod.ignoreProductTypeInDesignName && selectedCategory) {
            const parentProductsMap = _.keyBy(selectedCategory?.parentProducts, 'name');
            const currentParentProduct = parentProductsMap[commonDetail?.parent];

            const sizesMap = _.keyBy(currentParentProduct.sizes, 'name');
            const currentSize = sizesMap[commonDetail.size];

            if (!_.isEmpty(currentParentProduct)) {
                designNameList.push(currentParentProduct.name);
            }

            if (!_.isEmpty(currentSize)) {
                designNameList.push(currentSize.name);
            }
        }

        return _.join(designNameList, ' | ');
    }

    const prepareDesignList = () => {
        const newDesignList = [];
        const existingQuoteList = [...quoteList];

        _.forEach(existingQuoteList, quote => {
            if (quote.selected) {
                const newDesign = _.cloneDeep(commonDetail);
                newDesign.name = quote.designName;
                newDesign.quoteName = quote.startText;
                newDesign.quoteId = quote.id;

                copyDesignDetails(newDesign)
                newDesignList.push(newDesign);
            }
        });

        // console.log({newDesignList, quoteList, parentProduct})

        setDesignList(newDesignList);
    }

    const copyDesignDetails = (newDesign) => {
        if (!selectedDesignByQuoteMap?.hasOwnProperty(newDesign?.quoteId)) {
            return;
        }

        const copiedDesign = selectedDesignByQuoteMap[newDesign?.quoteId];
        _.forIn(copiedDesign, (value, attribute) => {
            if (IGNORE_COPY_ATTRIBUTES.indexOf(attribute) === -1 && !newDesign.hasOwnProperty(attribute)) {
                newDesign[attribute] = value;
            }
        })
    }

    const handleSearchDesigns = async (existingCommonDetail) => {
        const searchCriteriaList = [];

        _.forIn(existingCommonDetail, (value, field) => {
            if (!_.isEmpty(value) && !(field === 'podName' || field === 'themeName')) {
                searchCriteriaList.push({field: field, condition: '==', value: value});
            }
        });

        // console.log('searchCriteriaList: ', searchCriteriaList);

        if (existingCommonDetail.themeId && searchCriteriaList.length >= 6) {
            const designsListResult = await searchDesigns(searchCriteriaList);
            const designQuotes = _.map(designsListResult, 'quoteName');
            setExistingDesignQuoteList(designQuotes);
        }

    }

    const getSingleParentProductByDesignDetail = async (currentParentProduct) => {
        const existingCommonDetail = {...commonDetail};

        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'podId', condition: '==', value: existingCommonDetail?.podId});
        searchCriteriaList.push({field: 'market', condition: '==', value: existingCommonDetail?.market});
        searchCriteriaList.push({field: 'productType', condition: '==', value: existingCommonDetail?.productType});
        searchCriteriaList.push({field: 'category', condition: '==', value: existingCommonDetail?.category});
        searchCriteriaList.push({field: 'name', condition: '==', value: currentParentProduct?.name});

        searchParentProducts(searchCriteriaList)
            .then(async parentProductsList => {
                setParentProduct(parentProductsList[0]);
            });
    }

    const copyDesignList = (designsList, isExcludeTemplate) => {
        setSelectedDesignList(designsList);
        setSelectedDesignByQuoteMap(_.keyBy(designsList, 'quoteId'));
        setExcludeTemplate(isExcludeTemplate);
    }

    return (
        <>
            <div className="">

                <div className="ml-6 flex justify-start">
                    <div className="field-group-container">

                        <div className="field-container">
                            <div className="field-label">
                                POD
                            </div>
                            <select
                                className="input-field"
                                id="podId"
                                name="podId"
                                value={commonDetail?.podId}
                                onChange={handleDetailChanges}>
                                <option value="">Choose POD</option>
                                {podList?.map((pod, index) => (
                                    <option key={index}
                                            value={pod?.id}>{pod?.displayLabel}</option>
                                ))}
                            </select>
                        </div>

                        {selectedPod &&
                            <div className="field-container">
                                <div className="field-label">
                                    Product Type <span
                                    className="pl-1 text-gray-400">({selectedPod?.productTypesList?.length})</span>
                                </div>
                                <select
                                    className="input-field"
                                    id="productType"
                                    name="productType"
                                    value={commonDetail?.productType}
                                    onChange={handleDetailChanges}>
                                    <option value="">All Product Types</option>
                                    {selectedPod?.productTypesList?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                        {selectedProductType &&
                            <div className="field-container">
                                <div className="field-label">
                                    Category
                                    {selectedProductType &&
                                        <span
                                            className="pl-1 text-gray-400">({selectedProductType?.categories?.length})</span>
                                    }
                                </div>
                                <select
                                    className="input-field"
                                    id="category"
                                    name="category"
                                    value={commonDetail?.category}
                                    onChange={handleDetailChanges}>
                                    <option value="">Choose Category</option>
                                    {selectedProductType?.categories?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                        {selectedCategory &&
                            <div className="field-container">
                                <div className="field-label">
                                    Parent Product
                                    {selectedCategory &&
                                        <span
                                            className="pl-1 text-gray-400">({selectedCategory?.parentProducts?.length})</span>
                                    }
                                </div>
                                <select
                                    className="input-field"
                                    id="parent"
                                    name="parent"
                                    value={commonDetail?.parent}
                                    onChange={handleDetailChanges}>
                                    <option value="">Choose Parent Product</option>
                                    {selectedCategory?.parentProducts?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                        {selectedParentProduct && parentProduct?.isMultiMeasurement &&
                            <div className="field-container">
                                <div className="field-label">
                                    Product Size
                                </div>
                                <select
                                    className="input-field"
                                    id="size"
                                    name="size"
                                    value={commonDetail?.size}
                                    onChange={handleDetailChanges}>
                                    <option value="">Choose Size</option>
                                    {selectedParentProduct?.sizes?.map((size, index) => (
                                        <option key={index}
                                                value={size?.name}>{size?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                    </div>
                </div>

                <div className="ml-6 flex justify-start">
                    <div className="field-group-container">

                        <div className="field-container">
                            <div className="field-label">
                                Theme
                            </div>
                            <select
                                className="input-field"
                                id="themeId"
                                name="themeId"
                                value={commonDetail?.themeId}
                                onChange={handleDetailChanges}>
                                <option value="">Choose Theme</option>
                                {themeList?.map((theme, index) => (
                                    <option key={index}
                                            value={theme?.id}>{theme?.startText}</option>
                                ))}
                            </select>
                        </div>

                        <div className="mt-7 ml-4">
                            {selectedTheme && selectedPod &&
                                <CopyDesigns
                                    currentTheme={selectedTheme}
                                    currentPod={selectedPod}
                                    copyDesignList={copyDesignList}/>
                            }
                        </div>

                    </div>

                </div>

                <div className="my-4">
                    <ShowTabsList
                        setSelectedTab={setSelectedTab}
                        selectedTab={selectedTab}
                        tabsList={tabsList}/>
                </div>

                {selectedTab?.key === 'parent-product' && parentProduct &&
                    <div className="w-full">
                        <ParentProductDetail
                            parentProduct={parentProduct}
                            setParentProduct={setParentProduct}
                            allTags={allTags}/>
                    </div>
                }

                {selectedTab?.key === 'designs' && quoteList &&
                    <div className="flex justify-start mt-2">
                        <table className=" m-2">
                            <thead className="">
                            <tr>
                                <th className="px-2 py-2 border border-gray-400 bg-gray-400 text-white">
                                    Quote
                                </th>
                                <th className="px-2 py-2 border border-gray-400 bg-gray-400 text-white">
                                    {!quoteList &&
                                        <div>Select</div>
                                    }

                                    {quoteList &&
                                        <button onClick={selectAllQuotes}
                                                className="button-gray-outline px-4 h-10 ml-2">
                                            Select All
                                        </button>
                                    }
                                </th>
                                <th className="px-2 py-2 border border-gray-400 bg-gray-400 text-white">
                                    Design Name
                                </th>

                                <th colSpan={3} className="px-2 py-2 border border-gray-400 bg-gray-400 text-white">
                                    Copied Design Details
                                </th>

                            </tr>
                            </thead>
                            <tbody className="">
                            {quoteList?.map((quote, index) => (
                                <tr key={`quote-${index}`} className="border border-gray-400">
                                    <td className="p-2 border-r border-gray-400">
                                        <div className="field-label-bold ml-2">{quote?.startText}</div>
                                    </td>
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="flex justify-center">
                                            {(existingDesignQuoteList?.indexOf(quote.startText) === -1 || selectedDesignByQuoteMap?.hasOwnProperty(quote.id)) &&
                                                <>
                                                    {!quote?.selected &&
                                                        <button
                                                            className="button-small py-1"
                                                            onClick={() => toggleQuoteSelection(quote, index)}>
                                                            Select
                                                        </button>
                                                    }

                                                    {quote?.selected &&
                                                        <button
                                                            className="button-small button-green py-1"
                                                            onClick={() => toggleQuoteSelection(quote, index)}>
                                                            Selected
                                                        </button>
                                                    }
                                                </>
                                            }

                                            {(existingDesignQuoteList?.indexOf(quote.startText) !== -1 && !selectedDesignByQuoteMap?.hasOwnProperty(quote.id)) &&
                                                <div>Already Added</div>
                                            }
                                        </div>
                                    </td>

                                    <td className="p-2 border-r border-gray-400">
                                        <div className="field-label-bold ml-2">{quote?.designName}</div>
                                    </td>

                                    <td className="p-2 border-r border-gray-400">
                                        {selectedDesignByQuoteMap &&
                                            <div className="field-label-bold ml-2 mr-2">
                                                {selectedDesignByQuoteMap[quote.id]?.name}
                                            </div>
                                        }
                                    </td>

                                    <td className="p-2 border-r border-gray-400">
                                        {selectedDesignByQuoteMap &&
                                            <div className="flex justify-center items-center px-2">
                                                <ShowDesignStatistics
                                                    designDetail={selectedDesignByQuoteMap[quote.id]}/>
                                            </div>
                                        }
                                    </td>

                                    <td className="p-2">
                                        {selectedDesignByQuoteMap &&
                                            <DownloadDesignVariants
                                                designDetail={selectedDesignByQuoteMap[quote.id]}
                                                parentProduct={parentProduct}
                                                updateVariantColorsInDesign={undefined}
                                                isAssignColors={false}
                                                isPreview={true}
                                                isLightButton={false}
                                                setDesignDetail={undefined}/>
                                        }
                                    </td>

                                </tr>
                            ))}

                            </tbody>
                        </table>
                    </div>
                }

            </div>
        </>
    )
}

export default MultipleDesignDetails
